// Node imports
import { dispatcher, ingenuity } from "@quest/base-core";
import { BehaviorCoreModule, FreeGameState, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist/"
import { RetriggerControllerGame } from "../Retrigger/RetriggerControllerGame";
import { StickyFeatureView } from "../StickyWildFeature/StickyFeatureView";
import { StickyFeatureViewController } from "../StickyWildFeature/StickyFeatureViewController";
import { slot } from "@quest/slot-core";
import { StackSymbolFeatureControllerFgGame } from "../StackFeature/StackSymbolFeatureControllerFgGame";

export class FreeGameStateGame extends FreeGameState {
    private stickyFeature: StickyFeatureView;  

    init(): void {
        super.init();
        this.initializeStickyFeature();
    }
    protected initializeRetrigger(): void {
        if (!this.retriggerView) {
            this.retriggerView = new BehaviorCoreModule.RetriggerView(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).reTrigger);
            this.retriggerController = new RetriggerControllerGame(this.retriggerView, this.view);
            ingenuity.currentGame.stage.addChildAt(this.retriggerView, ingenuity.currentGame.stage.children.length - 2);
        }
        dispatcher.fireEvent(SlotEventConstantsBehavior.START_RETRIGGER_PRESENTATION);
    }

    /**
    * This will initialize the sticky feature at start of freegame
    */
    private initializeStickyFeature(): void {
        if (!this.stickyFeature) {
        this.stickyFeature = new StickyFeatureView(ingenuity.assetsData.getJSONById(slot.SlotConstants.MainData).stickyWildSymbol);
        new StickyFeatureViewController(this.stickyFeature,this.model);
        }
        this.setLayering(this.stickyFeature);
        //ingenuity.currentGame.stage.addChild(this.stickyFeature);
    }
    protected initializeStackSymbolFeatureFG(): void {
        if (!this.stackSymbolViewFG) {
            this.stackSymbolViewFG = new BehaviorCoreModule.StackSymbolFeatureViewFG(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).stackSymFG);
            this.stackSymbolControllerFG = new StackSymbolFeatureControllerFgGame(this.stackSymbolViewFG);
            this.setLayering(this.stackSymbolViewFG);
        }
    }
}
